/**
 * Deellink voor een wensenlijst (en optioneel je bezochte musea): alleen museum-ID's, geen persoonlijke data.
 * Een ontvangen link wordt gevalideerd tegen de bekende musea; onbekende ID's vallen weg.
 */
export interface WensShare {
  /** museum-ID's op de wensenlijst */
  w: string[];
  /** museum-ID's die de deler al bezocht heeft (optioneel, alleen ter info) */
  b?: string[];
}

const MAX = 1000;

export function maakWensValidator(bekend: ReadonlySet<string>) {
  return (raw: unknown): WensShare | undefined => {
    if (!raw || typeof raw !== 'object') return undefined;
    const { w, b } = raw as Record<string, unknown>;
    if (!Array.isArray(w)) return undefined;
    const ids = (lijst: unknown[]) => [...new Set(lijst.filter((x): x is string => typeof x === 'string' && bekend.has(x)))].slice(0, MAX);
    const wens = ids(w);
    const bezocht = Array.isArray(b) ? ids(b) : [];
    if (!wens.length && !bezocht.length) return undefined;
    return bezocht.length ? { w: wens, b: bezocht } : { w: wens };
  };
}
